// React
import { memo, useCallback, useState } from "react";

// Helpers
import { classNames, useTranslate } from "helpers";

// Types
import { TableRowChildProps } from "ui/components/Table/TableSearch/types";

// Routing


// Third-party libs
// UI Components
import { Dialog } from "ui/components/Dialog";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { deleteFleetTireAPI } from "services/api/fleet/tires/api";


interface VehicleTireRowChildProps extends TableRowChildProps {
    disableDelete?: boolean;
}

const VehicleTireRowChild: React.FC<VehicleTireRowChildProps> = (props) => {
    const { index, row, onFetchSearchResult, disableDelete } = props;

    const { t } = useTranslate();

    const [tireId, setTireId] = useState<string>("");
    const [openDialog, setOpenDialog] = useState(false);


    const handleDeleteClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, id: string) => {
        event.stopPropagation();
        event.preventDefault();

        setTireId(id);
        setOpenDialog(true);
    }

    const handleDriverDeleteDialogConfirm = useCallback(async () => {
        if (!tireId) return;

        try {
            const deleted = await deleteFleetTireAPI(
                tireId,
                t
            );

            if (deleted && onFetchSearchResult) {
                await onFetchSearchResult();

            }

            // zatvori dijalog nakon brisanja
            setOpenDialog(false);
            setTireId("");
        } catch (err) {
            console.error("Greška prilikom brisanja gume:", err);
        }
    }, [tireId, t]);

    const handleDriverDeleteDialogClose = useCallback(() => {
        setTireId("");
        setOpenDialog(false);
    }, []);


    return (
        <>
            <tr className={classNames(
                "hover:bg-slate-100",
                index % 2 === 0 ? "bg-white" : " bg-slate-50"
            )}>
                <td className={classNames("px-4 py-2 text-sm font-medium flex-1")}>
                    {row.width}/{row.height} R{row.radius}
                </td>
                <td className={classNames("px-4 py-2 text-sm font-medium flex-1")}>
                    {row.tireType?.name}
                </td>
                <td className={classNames("px-4 py-2 text-sm font-medium flex-1")}>
                    {row.tireManufacturer?.name}
                </td>
                <td className={classNames("px-4 py-2 text-sm font-medium flex-1")}>
                    {row.dot}
                </td>
                <td className={classNames("px-4 py-2 text-sm font-medium flex-1")}>
                    {row.profileDepth}
                </td>
                <td className="py-1.5">
                    {!disableDelete && (
                        <ButtonMenu
                            endIcon="/media/icons/more-dots.svg"
                            cssClassName="h-full"
                            variant="text"
                        >
                            <ButtonMenuItem
                                startIcon="/media/icons/trash.svg"
                                variant="remove"
                                onClick={(e) => handleDeleteClick(e, row.id)}
                            >
                                Obriši
                            </ButtonMenuItem>
                        </ButtonMenu>
                    )}
                </td>
            </tr>
            <Dialog
                open={openDialog}
                title={t(
                    "admin.fleet.vehicle.tire.dialog.delete.title"
                )}
                message={t(
                    "admin.fleet.vehicle.tire.dialog.delete.message"
                )}
                confirmText={t(
                    "admin.fleet.vehicle.tire.dialog.delete.confirmtext"
                )}
                cancelText={t(
                    "admin.fleet.vehicle.tire.dialog.delete.canceltext"
                )}
                onConfirm={handleDriverDeleteDialogConfirm}
                onCancel={handleDriverDeleteDialogClose}
            />
        </>
    );
};

export default memo(VehicleTireRowChild);
